const FaveContent = [
    {
        name:"Acne Pimple Master Patch",
        brand:"CosRX",
        imgurl:"https://cdn.shopify.com/s/files/1/0513/3775/6828/products/acnepimplepatch_01_800x.jpg?v=1610006208",
        price:"250",
        category:"skin",
        description:"A pimple patch that takes the dirt out of pores immediately"
    },

    {
        name:"Ultimate Nourishing Rice Overnight Mask",
        brand:"CosRX",
        imgurl:"https://cdn.shopify.com/s/files/1/0513/3775/6828/products/propolisovernightmask_06.jpg?v=1611735335",
        price:"729",
        category:"skin",
        description:"A neutral smelling overnight mask that leaves you nourished in the morning"
    },

    {
        name:"AHA/BHA Clarifying Treatment Toner",
        brand:"CosRX",
        imgurl:"https://s3.ap-south-1.amazonaws.com/vely-prod-media-bucket/products/7_COSRX_AHABHA-Clarifying-Treatment-Toner.jpg",
        price:"612",
        category:"skin",
        description:"The holy grail toner that removes blackheads and whiteheads"
    },

    {
        name:"Salicylic Acid Daily Gentle Cleanser",
        brand:"CosRX",
        imgurl:"https://ph-test-11.slatic.net/p/5779388d9c1bf4642d83b7008b42f072.jpg",
        price:"355",
        category:"skin",
        description:"The best cleanser that removes blackheads and whiteheads"
    },

    {
        name:"Green Grape Pore Control Cream",
        brand:"Frudia",
        imgurl:"https://images-na.ssl-images-amazon.com/images/I/51Ef6wT2cPL.jpg",
        price:"150",
        category:"skin",
        description:"A sweet-smelling cold-feeling cream that minimizes pores"
    },

    {
        name:"GimmeBrow Volumizing Eyebrow Gel",
        brand:"Benefit",
        imgurl:"https://images.ulta.com/is/image/Ulta/2529256?op_sharpen=1&resMode=bilin&qlt=85&wid=800&hei=800&fmt=jpg",
        price:"930",
        category:"Face",
        description:"A brow gel that lasts all day"
    },

    {
        name:"Roller Liner Brown",
        brand:"Benefit",
        imgurl:"https://www.lifepharmacy.co.nz/globalassets/product-images/gxh_11282384-0.jpg?width=500&height=500&mode=crop",
        price:"1590",
        category:"beauty",
        description:"A felt tip liner that will give you the most natural cat eyes"
    },

    {
        name:"Facial Moisturizer",
        brand:"Celeteque",
        imgurl:"https://ph-live-02.slatic.net/p/01bed20925ce89e4df16f8e9128edd15.jpg",
        price:"199",
        category:"skin",
        description:"I really hate sticky hands, so this water based moisturizer is really for me. It is very cool to the skin"
    },

    {
        name:"UV Aqua Rich Watery Essence",
        brand:"Biore",
        imgurl:"https://uploads.beautymnl.com/spree/product_images/257891/original/Biore.jpg?1645708078",
        price:"488",
        category:"skin",
        description:"This water based sunblock is also very cool to the skin. The lightness also makes you feel refreshed"
    },

    {
        name:"Witch Hazel Rose Toner",
        brand:"Thayers",
        imgurl:"https://www.calyxta.com/wp-content/uploads/2018/03/Thayers-Alcohol-Free-Rose-Petal-Witch-Hazel-Toner.jpg",
        price:"695",
        category:"skin",
        description:"I realized just now that I love products that cool the skin. I spam this toner over my face whenever its too hot"
    },

    {
        name:"Retinol 2.5 Serum",
        brand:"Cos de BAHA",
        imgurl:"https://cf.shopee.ph/file/e8d6f035922c0307e8a28b453b8fc4a1",
        price:"455",
        category:"skin",
        description:"This serum really works wonders after two days. It helps minimizes the apearance of my pores"
    },

    {
        name:"Skin Tint Sun Shield ",
        brand:"Blk Cosmetics",
        imgurl:"https://www.blkcosmetics.com.ph/4611-big_default_2x/blk-cosmetics-skintint-sun-shield-spf-30-butterscotch.jpg",
        price:"499",
        category:"Face",
        description:"This sheer skin tint is my holy grail. Thanks to the other products I don't need foundation."
    },
]

export default FaveContent